import { Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
import { GrouperListComponent } from '../grouper-list/grouper-list.component';
import { RecurrenceType } from '@app/shared/models/enums/recurrence-type.enum';
import { RecurrenceUnit } from '@app/shared/models/enums/recurrence-unit.enum';
import { Router } from '@angular/router';
import { NavigationService } from '@app/core/services/navigation.service';

@Component({
    selector: 'app-maintenance-accordion',
    templateUrl: './maintenance-accordion.component.html',
    styleUrls: ['./maintenance-accordion.component.scss']
})
export class MaintenanceAccordionComponent implements OnInit {
    @ViewChildren(GrouperListComponent) grouperLists: GrouperListComponent[];

    @Input() items = [];
    @Input() readonly = false;
    @Input() grouperOnly = false;

    @Output() itemClicked = new EventEmitter<any>();
    @Output() selectionChanged = new EventEmitter<any>();

    constructor(private router: Router, private navigationService: NavigationService) {
    }

    ngOnInit() {
    }

    resetSelected() {
        this.items.forEach(item => {
            item.selected = false;
            item.selectedItems = [];
        });
    }

    toggleExpanded(index: number) {
        this.items[index].expanded = !this.items[index].expanded;
    }

    toggleSelected(event: any, index: number) {
        event.preventDefault();
        event.stopPropagation();

        if (this.readonly) {
            return;
        }

        this.items[index].selected = !this.items[index].selected;
        this.items[index].expanded = this.items[index].selected;
    }

    get selectedItems() {
        const itemsWithRecurrences = this.items.filter(item => item.items.length > 0);
        this.grouperLists.forEach((gl, i) => {
            const itemWithRecurrences = itemsWithRecurrences.find(e => e.id === gl.index)
            if (itemWithRecurrences) {
                itemWithRecurrences.selectedItems = gl.selectedItems;
            }
        });

        this.items.forEach(item => {
            item = itemsWithRecurrences.find(e => e.id === item.id)
        });

        return this.items.filter(item => item.selected);
    }

    hasContent(i: number) {
        return (this.items[i].items && this.items[i].items.length > 0)
            || (this.items[i].selectedItems && this.items[i].selectedItems.length > 0);
    }

    onSelect({index, i}) {
        let selectedItem = this.items.find(x => x?.id === index);
        selectedItem = selectedItem ? selectedItem : this.items[index];

        if (selectedItem.items[i].selectionData.isMandatory) {
            return;
        }
        selectedItem.items[i].selectionData.isSelected = !selectedItem.items[i].selectionData.isSelected;

        // when a recurrence of type time or cycle is pressed, all the smaller recurrences are also selected
        if (selectedItem.items[i].type !== RecurrenceType.RETURN && selectedItem.items[i].selectionData.isSelected === true) {
            selectedItem.items.forEach((item) => {
                if (item.type === selectedItem.items[i].type) {
                    if ((selectedItem.items[i].unit === RecurrenceUnit.MONTHS && item.unit !== RecurrenceUnit.MONTHS)
                        || (selectedItem.items[i].unit === RecurrenceUnit.WEEKS && item.unit === RecurrenceUnit.DAYS)
                        || (selectedItem.items[i].unit === item.unit && selectedItem.items[i].value > item.value)) {
                        item.selectionData.isSelected = true;
                    }
                }
            });
        }

        this.selectionChanged.emit(this.items);
    }

    navigateTo(event: any, link: string) {
        event.stopPropagation();
        event.preventDefault();

        this.navigationService.addToHistory(this.router.url);
        this.router.navigateByUrl(link);
    }

    onItemClicked(event: any) {
        this.itemClicked.emit(event);
    }
}
